export enum SynchronizationStepName {
  Projects = 'projects',
  Roads = 'roads',
  Certifications = 'certifications',
  CertificationInputs = 'certification-inputs',
  CertificationItems = 'certification-items',
  Progress = 'progress',
  Progressitems = 'progress-items',
  PendingCertifications = 'pending-certifications',
  PendingProgress = 'pending-progress'
}

export enum SynchronizationStepStatus {
  Pending = 'pending',
  Running = 'running',
  Success = 'success',
  Error = 'error',
}